import React from 'react';

interface LoaderProps {}

const Loader: React.FC<LoaderProps> = () => {
  return (
    <div className="flex justify-center">
      <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full border-t-customPrimary"></div>
    </div>
  );
};

export default Loader;
